import {
  AfterViewInit,
  Component,
  ElementRef, inject,
  Input,
  OnInit,

} from "@angular/core";
import { UserVote } from "../../shared/interfaces";

@Component({
    selector: 'asset-voters',
    templateUrl: './asset-voters.component.html',
    styleUrls: ['./asset-voters.component.scss'],
    standalone: false
})
export class AssetVotersComponent implements OnInit {
  @Input() tooltipHost: ElementRef;
  @Input() avatarSize: number = 22;
  @Input() viewMode: 'inline' | 'tooltip' = 'inline';

  private _voters: UserVote[] = [];
  private _inlineLimit: number = 2;
  inlineVoters: UserVote[] = [];

  get voters(): UserVote[] {
    return this._voters;
  }

  @Input() set voters(value: UserVote[]) {
    this._voters = value;
    this.updateState();
  }

  get inlineLimit(): number {
    return this._inlineLimit;
  }

  @Input() set inlineLimit(value: number) {
    this._inlineLimit = value;
    this.updateState();
  }

  totalOthers: number = 0;

  ngOnInit() {
  }

  private updateState() {
    this.totalOthers = this.voters.length - this.inlineLimit;
    this.inlineVoters = this.voters.slice(0, this.inlineLimit);
  }

}
